export class RoleDetailVM {
    roleName: string;
    description: string;
    roleID: number;
    isActive: boolean;
    rolePermissions: any[] ;
    OrganizationID: number;
}
